<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light border mb-3">
      <a class="navbar-brand" href="#">Bazar compra</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <form @submit.prevent="buscar" class="form-inline my-2 my-lg-0 mr-auto">
          <input class="form-control mr-sm-1" type="date" v-model="fbuscar.fdel" required>
          <input class="form-control mr-sm-1" type="date" v-model="fbuscar.fal" required>
          <input type="search" class="form-control mr-sm-1" v-model="fbuscar.termino" placeholder="Compra, código o usuario" style="width:250px;">
          <button class="btn btn-info my-2 my-sm-0 mr-sm-1" type="submit" :disabled="cargando">
            <font-awesome-icon icon="search"/>
          </button>
          <button class="btn btn-success my-2 my-sm-0" type="button" @click="exportar">
            <font-awesome-icon icon="download"/>
          </button>
        </form>
        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" class="nav-link dropdown-toggle">
              <span v-if="accion.enviando">{{ accion.mensaje }}</span>
              <span v-else>Acción</span>
            </a>
            <div
              aria-labelledby="navbarDropdown"
              class="dropdown-menu dropdown-menu-right"
            >
              <template v-for="i in acciones">
                <a
                  href="#"
                  class="dropdown-item"
                  @click.prevent="actualizar(i.id)"
                  :key="i.id"
                >{{ i.descripcion }}</a>
              </template>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <div v-if="!lista">
      <div class="alert alert-warning text-center" role="alert">
        No hay registros para mostrar
      </div>
    </div>
    <table class="table table-bordered table-sm" id="tablaCompra" v-if="lista">
      <thead>
        <tr>
          <th>#</th>
          <th width="200px">Número de compra</th>
          <th>Modalidad</th>
          <th>Fecha de compra</th>
          <th>Fecha de confirmación</th>
          <th>Código de empleado</th>
          <th>Usuario</th>
          <th class="text-right">Total</th>
          <th>
            <input type="checkbox" v-model="todo">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="cargando">
          <td colspan="100%">Cargando información...</td>
        </tr>
        <tr v-if="!cargando && lista.length == 0">
          <td colspan="100%">No hay compras confirmadas</td>
        </tr>
        <template v-else>
          <template v-for="(r, i) in lista">
            <tr v-if="r.anulada == 0" :key="i">
              <th>{{ (i+1) }}</th>
              <td>
                <a :href="`${UrlBase}/bazar/impresion/${r.id}`">{{ r.id }}</a> 
                <template v-if="r.modo == 2">
                  <span
                    class="badge ml-1"
                    :class="r.autorizada == 1 ? 'badge-success':'badge-secondary'"
                  >{{ r.autorizada == 1 ? 'Autorizada':'Pendiente' }}</span>
                </template>
              </td>
              <td>{{ r.modalidad }}</td>
              <td>{{ r.fecha }}</td>
              <td>{{ r.fecha_confirmacion }}</td>
              <td>{{ r.codigo_empleado }}</td>
              <td>{{ r.usuario }}</td>
              <td class="text-right">
                <a 
                  href="#" 
                  @click.prevent="verDetalle(i)"
                  data-toggle="modal"
                  data-target="#mdlDetalle"
                  >
                  Q. {{ parseFloat(r.total).toFixed(2) }}
                </a>
              </td>
              <td>
                <input type="checkbox" v-model="seleccion" :value="{ idx: i, id: r.id }">
              </td>
            </tr>
          </template>
        </template>
      </tbody>
      <tfoot>
        <tr>
          <th class="text-right" colspan="7">TOTAL:</th>
          <th class="text-right">Q. {{ totalCompras }}</th>
          <th></th>
        </tr>
      </tfoot>
    </table>

    <div class="modal fade" id="mdlDetalle" tabindex="-1" role="dialog" aria-labelledby="mdlDetalleLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="mdlDetalleLabel">Detalle de compra {{ reg.id }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-sm">
              <thead>
                <tr class="thead-light">
                  <th>Producto</th>
                  <th>Proveedor</th>
                  <th class="text-center">Cantidad</th>
                  <th class="text-right">Precio</th>
                  <th class="text-right">Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="reg.detalle">
                <tr v-for="(d, i) in reg.detalle" :key="i">
                  <td class="text-wrap" style="width: 30rem;">{{ d.producto }}</td>
                  <td>{{ d.nproveedor }}</td>
                  <td class="text-center">{{ d.cantidad }}</td>
                  <td class="text-right">Q. {{ parseFloat(d.precio).toFixed(2) }}</td>
                  <td class="text-right">Q. {{ parseFloat(d.total).toFixed(2) }}</td>
                  <td class="text-center">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      v-if="btnDetalle == d.id"
                    ></span>
                    <small v-else>
                      <a href="#" @click.prevent="anularCompra(2,i)" class="text-danger">
                        <font-awesome-icon icon="times"/>
                      </a>
                    </small>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="4" class="text-right">
                    Total
                  </th>
                  <th class="text-right">
                    Q. {{ parseFloat(totalDetalle).toFixed(2) }}
                  </th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ManteAccion from '../mixins/ManteAccion.js';
  import axios from 'axios';

  export default {
    name: 'BazarCompra',
    mixins:[ManteAccion],
    data: () => ({
      cargando: false,
      btnCompra: false,
      btnDetalle: false,
      todo: false,
      seleccion: [],
      fbuscar: {
        fdel: null,
        fal: null
      },
      lista: [],
      reg: [],
      acciones: [
        { id: 1, descripcion: 'Anular' },
        { id: 2, descripcion: 'Autorizar' }
      ],
      accion: {
        mensaje: 'Procesando...',
        enviando: false
      }
    }),
    created() {
      this.fbuscar.fdel = new Date().toJSON().slice(0,8)+'01';
      this.fbuscar.fal = new Date().toJSON().slice(0,10);
    },
    methods: {
      buscar() {
        this.cargando = true;
        this.lista = [];
        axios
        .get(`${this.UrlBase}/bazar/buscar_compras`, {params:this.fbuscar})
        .then((res) => {
          if (res.data.lista) {
            this.lista = res.data.lista
          } else {
            this.lista = [];
          }
          this.cargando = false;
        }).catch((error) => {
          this.cargando = false;
          alert('Compras '+error);
        })
      },
      verDetalle(idx) {
        let reg = this.lista[idx];
        this.reg = reg ?? {}
      },
      actualizar (accion) {
        var continuar = prompt('Agregue un comentario')

        if (continuar) {
          this.accion.enviando = true
          axios
          .post(`${this.UrlBase}/bazar/actualizar_compra/${accion}`, {
            compras: this.seleccion,
            comentario: continuar
          })
          .then(res => {
            this.showSuccessMsg({message: res.data.mensaje});

            if (res.data.exito) {
              for (let i=0; i < res.data.compras.length; i++) {
                let com = res.data.compras[i]
                this.lista[com.idx].autorizada = com.autorizada
                this.lista[com.idx].anulada = com.anulada
              }
            }

            this.accion.enviando = false
            this.seleccion = []
          }).catch(e => {
            this.accion.enviando = false
            alert('Anular '+e);
          });
        }
      },
      anularCompra(tipo, idx) {
        if (confirm('¿Esta seguro de anular?')) {
          let regTmp = null;
          let datos  = {};

          if (tipo == 2) {
            regTmp = this.reg.detalle[idx];
            datos.detalle = regTmp.id;
            this.btnDetalle = regTmp.id;
          } else {
            regTmp = this.lista[idx];
            datos.compra = regTmp.id;
            this.btnCompra = regTmp.id;
          }

          axios
          .post(`${this.UrlBase}/bazar/anular_compra`, datos)
          .then(res => {
            if (res.data.exito) {
              if (tipo == 2) {
              
                let tmp = this.lista.filter(e => {
                  return e.id == this.reg.detalle[idx].compra
                })[0];
                this.reg.detalle.splice(idx, 1);
                
                if (tmp) {
                  tmp.total = this.totalDetalle;
                  tmp.detalle.splice(idx, 1);
                }
              } else {
                this.lista.splice(idx, 1);
              }
              this.showSuccessMsg({message: res.data.mensaje});
            } else {
              this.showErrorMsg({message: res.data.mensaje});
            }

            this.btnDetalle = false;
            this.btnCompra  = false;
          }).catch(e => {
            this.btnDetalle = false;
            this.btnCompra  = false;
            alert('Anular '+e);
          });
        }
      },
      exportar () {
        let tab_text='<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN"><html><head><meta http-equiv="content-type" content="text/html; charset=UTF-8"/><title></title><meta name="generator" content="Gacela C807"/><style type="text/css">body,div,table,thead,tbody,tfoot,tr,th,td,p { font-family:"Liberation Sans"; font-size:x-small }</style></head><body><table>';

        let tab = document.getElementById('tablaCompra');

        for(let j = 0 ; j < tab.rows.length ; j++) {
          tab_text = tab_text+"<tr>"+tab.rows[j].innerHTML+"</tr>";
        }

        tab_text = tab_text+"</table></body></html>";
        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
        tab_text = tab_text.replace(/<img[^>]*>/gi,"");
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi,"");

        var a = document.createElement('a') 
        a.href = 'data: application/vnd.ms-excel,' + encodeURIComponent(tab_text)
        a.download = 'compras.xls'
        a.click()

        return false;
      }
    },
    computed: {
      totalDetalle() {
        let total = 0;

        if (this.reg && this.reg.detalle) {
          this.reg.detalle.forEach((el) => {
            total += parseFloat(el.total)
          })
        }

        return total;
      },
      totalCompras() {
        let total = 0;
        if (this.lista) {
          this.lista.forEach(e => {
            if (e.anulada == 0) {
              total += e.total
            }
          });
        }

        return parseFloat(total).toFixed(2);
      }
    },
    watch: {
      todo (value) {
        this.seleccion = value ? {...this.lista} : []
      }
    }
  }
</script>